import moize from 'moize';
import { createSelector } from '@reduxjs/toolkit';
import { useAppSelector } from '@/store/hooks';
// Base selector to get areas state from Redux store
export const areasStateSelector = (state) => {
    var _a;
    return (_a = state.areas) !== null && _a !== void 0 ? _a : {
        items: [], loaded: false, loading: false, error: null,
    };
};
// Selector to get all areas items
export const areasItemsSelector = createSelector([areasStateSelector], (areasState) => { var _a; return (_a = areasState === null || areasState === void 0 ? void 0 : areasState.items) !== null && _a !== void 0 ? _a : []; });
export const areasLoadedSelector = createSelector([areasStateSelector], (areasState) => areasState.loaded);
// Selector to get areas sorted by name
export const areasSortedByNameSelector = createSelector([areasItemsSelector], (unsortedAreas) => [...unsortedAreas].sort((a, b) => { var _a, _b; return ((_a = a === null || a === void 0 ? void 0 : a.name) !== null && _a !== void 0 ? _a : '').localeCompare((_b = b === null || b === void 0 ? void 0 : b.name) !== null && _b !== void 0 ? _b : ''); }));
// Memoized selector to get area ID by name and collection name
export const areaIdByNameAndCollectionIdSelector = moize((collectionId, areaName) => createSelector([areasItemsSelector], (areas) => {
    var _a;
    return (_a = areas.find((area) => area.collectionId === collectionId && area.name === areaName)) === null || _a === void 0 ? void 0 : _a.id;
}));
// Hook to get all areas
export const useAreasSelector = () => useAppSelector(areasSortedByNameSelector);
export const useAreasLoadedSelector = () => useAppSelector(areasLoadedSelector);
